import { z } from "zod";

export const phoneDtoSchema = z.object({
  id: z.number(),
  phone: z.string(),
  valid: z.boolean(),
  default: z.boolean(),
});

export type TPhoneDto = z.infer<typeof phoneDtoSchema>;
